import AlerterView from 'chairisher/view/alerter';

import { getTosErrorString } from 'chairisher/context/error';

/**
 *
 * @param {Object} jqXHR jqXHR response object from ajax request
 * @returns {boolean} Whether the ajax request responded with a ToS error
 */
export function isToSError(jqXHR) {
    return jqXHR.responseJSON?.errors?.[0]?.message === getTosErrorString();
}

/**
 *
 * @param {Object} jqXHR The jqXHR response object returned from the error event
 * @returns {Function} The call to fire an error alert with the provided error message
 */
export function renderAjaxErrorAlert(jqXHR) {
    return AlerterView.error(jqXHR.responseJSON?.errors?.[0]?.message);
}
